/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Preview_AniaInputs */

const en_platform_preview_ania = /** @type {(inputs: Platform_Preview_AniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ania Wiśniewska · Check-in`)
};

const pl_platform_preview_ania = /** @type {(inputs: Platform_Preview_AniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ania Wiśniewska · Pomiary`)
};

/**
* | output |
* | --- |
* | "Ania Wiśniewska · Check-in" |
*
* @param {Platform_Preview_AniaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_preview_ania = /** @type {((inputs?: Platform_Preview_AniaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Preview_AniaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_preview_ania(inputs)
	return en_platform_preview_ania(inputs)
});